import { all, call, put, takeLatest } from 'redux-saga/effects';

import { fetchEncodedData } from '../../../utility/requests';
import playersAndTeamsActionCreators from '../playersAndTeams/actionCreators';

import actionCreators from './actionCreators';
import actionTypes from './actionTypes';
import configSelectors from './selectors';

function* statsConfig() {
    try {
        const configUrl = `${window.__BASE_REST_URL__}/config`;
        const franchiseUrl = `${window.__BASE_REST_URL__}/franchise?sort=fullName&include=lastSeason.id&include=firstSeason.id`;
        const countryUrl = `${window.__BASE_REST_URL__}/country?include=stateProvinces&sort=countryName`;
        const seasonUrl = `${window.__BASE_REST_URL__}/season?sort=[{"property":"id","direction":"DESC"}]`;
        const componentSeasonUrl = `${window.__BASE_REST_URL__}/componentSeason`;
        const draftUrl = `${window.__BASE_REST_URL__}/draft?sort=draftYear`;

        const [configData, franchiseData, countryData, seasonData, componentSeason, draftData] = yield all([
            call(fetchEncodedData, configUrl),
            call(fetchEncodedData, franchiseUrl),
            call(fetchEncodedData, countryUrl),
            call(fetchEncodedData, seasonUrl),
            call(fetchEncodedData, componentSeasonUrl),
            call(fetchEncodedData, draftUrl),
        ]);

        const config = { ...configData };
        config.franchiseData = franchiseData.data.filter((f) => f.firstSeason);
        config.countryData = configSelectors.getSortedCountryData(countryData.data);
        config.seasonData = configSelectors.getSeasonData(seasonData.data);
        [config.fieldDefaultData] = componentSeason.data;
        config.draftData = draftData.data;

        yield put(actionCreators.statsConfigResponse(true, null, config));

        yield put(playersAndTeamsActionCreators.resetPlayersAndTeamsState(window.location.pathname));
    } catch (errors) {
        yield put(actionCreators.statsConfigResponse(false, errors, null));
    }
}

export default function* watchStatsConfig() {
    yield takeLatest(actionTypes.REQUEST_STATS_CONFIG, statsConfig);
}
